import { Injectable } from '@angular/core';

import { AnalyticsBase } from '@recruitee/analytics';

import type { ThemeName } from './theme-utils.service';

@Injectable({ providedIn: 'root' })
export class ThemeAnalytics extends AnalyticsBase {
  public readonly namespace = `Admin Preferences`;
  public readonly requireViewContext = false;

  public trackAppearancePageVisit(context: string) {
    this.track('Appearance page visited', { context });
  }

  public trackThemeSelected(value: ThemeName, context: string) {
    this.track('Theme selected', { value, context });
  }
}
